<template>
  <div
    @click.prevent="clicked"
    class="custom-radio"
    :class="{disabled: disabled}"
  >
    <div class="box" :class="{ checked: val === value }"><div class="inner" /></div>
    <label v-if="label" class="form-check-label font-weight-normal" >{{ label }}</label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `textarea-input-${this._uid}`;
      },
    },
    label: String,
    value: [String, Number],
    val: [String, Number],
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    clicked() {
      if (this.disabled) {
        return;
      }
      this.$emit('input', this.val);
    },
  },
};
</script>
